import { isAxiosError } from 'axios';

export function getApiErrorMessage(error: any) {
  let message = 'Something went wrong. Please try again later.';
  if (isAxiosError(error)) {
    message = `Error ${error.response?.status}: ${error.response?.data?.message || message}`;
  } else {
    message = error.message || message;
  }
  return message;
}
